export const travelClearanceSlotQualificationIds = [
  "b9a43d00-9f5b-4bda-9170-641af36636f9", // COVID TRAVEL RT PCR
  "911bcb02-de70-440d-96b6-b74532d564a3", // COVID ALASKA AIRLINES
];

export const defaultSlotQualificationIds = [
  "3c7fe322-a958-4814-9a77-ab21359d57ab", // Clinician
  ...travelClearanceSlotQualificationIds,
];
